import {
  GET_PROVIDERS_NUMBER,
  GET_PROVIDERS_NUMBER_ERROR,
  GET_PROVIDERS_NUMBER_SUCCESS,
  GET_PROVIDERS_PURCHASING_MECHANISM,
  GET_PROVIDERS_PURCHASING_MECHANISM_ERROR,
  GET_PROVIDERS_PURCHASING_MECHANISM_SUCCESS
} from './ProvidersGeneralDataSection.actions'

const providersGeneralDataSectionState = {
  error: null,
  loading: false,
  providersNumber: { csv: [], data: [] },
  purchasingMechanism: { csv: [], data: [] }
}

/**
 * The providers general data section's reducer.
 */
const providersGeneralDataSectionReducer = (state = providersGeneralDataSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDERS_NUMBER:
    case GET_PROVIDERS_PURCHASING_MECHANISM: {
      return { ...state, ...providersGeneralDataSectionState, loading: true }
    }
    case GET_PROVIDERS_NUMBER_ERROR:
    case GET_PROVIDERS_PURCHASING_MECHANISM_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDERS_NUMBER_SUCCESS: {
      return { ...state, loading: false, providersNumber: { ...state.providersNumber, ...payload } }
    }
    case GET_PROVIDERS_PURCHASING_MECHANISM_SUCCESS: {
      return { ...state, loading: false, purchasingMechanism: { ...state.purchasingMechanism, ...payload } }
    }
    default: {
      return state
    }
  }
}

export default providersGeneralDataSectionReducer
